module.exports = __webpack_public_path__ + "static/media/md-brush.3bdbc645.svg";